import common from './common.json';

export const es_MX = {
    common
};
